export default __webpack_public_path__ + "static/mock-reward-5-250078d169ff5752c48770a32d2a5e7b.webp";